import React from 'react';
import {
  ChartBarIcon,
  UsersIcon,
  CalendarIcon,
  ClipboardDocumentListIcon,
  NewspaperIcon,
  CloudIcon,
  BellIcon,
  CogIcon,
  ChatBubbleLeftRightIcon,
  UserGroupIcon,
  BuildingOfficeIcon,
  CreditCardIcon,
  ArrowRightOnRectangleIcon,
  ComputerDesktopIcon,
  DevicePhoneMobileIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

export default function AdminDashboardHelp() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* Header Section */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full mb-6">
            <ChartBarIcon className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Manager Dashboard Guide</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Your command center for managing teams, tracking performance, and staying organized
          </p>
        </div>

        {/* Overview Card */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <SparklesIcon className="w-6 h-6 text-blue-600" />
              </div>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">What is the Manager Dashboard?</h2>
              <p className="text-gray-600 text-lg leading-relaxed">
                Think of it as your business's control room. Everything you need to manage your team, track progress, and make decisions is organized in one beautiful, easy-to-use interface.
              </p>
            </div>
          </div>
        </div>

        {/* Dashboard Layout Diagram */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Dashboard Layout</h2>

          {/* Desktop Layout Diagram */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
              <ComputerDesktopIcon className="w-5 h-5 mr-2 text-blue-600" />
              Desktop View
            </h3>
            <div className="bg-gray-50 rounded-xl p-6 border-2 border-dashed border-gray-300">
              <div className="grid grid-cols-12 gap-4 h-64">
                {/* Sidebar */}
                <div className="col-span-2 bg-blue-100 rounded-lg p-3 border border-blue-200">
                  <div className="space-y-2">
                    <div className="w-full h-3 bg-blue-300 rounded"></div>
                    <div className="w-full h-3 bg-blue-300 rounded"></div>
                    <div className="w-full h-3 bg-blue-300 rounded"></div>
                    <div className="w-full h-3 bg-blue-300 rounded"></div>
                    <div className="w-full h-3 bg-blue-300 rounded"></div>
                  </div>
                  <p className="text-xs text-blue-700 mt-2 font-medium">Navigation</p>
                </div>
 <div className="col-span-3 space-y-3">
                  <div className="bg-orange-100 rounded-lg p-3 border border-orange-200">
                    <div className="w-full h-8 bg-orange-300 rounded mb-2"></div>
                    <p className="text-xs text-orange-700 font-medium">Weather</p>
                  </div>
                  <div className="bg-pink-100 rounded-lg p-3 border border-pink-200">
                    <div className="space-y-1">
                      <div className="w-full h-2 bg-pink-300 rounded"></div>
                      <div className="w-3/4 h-2 bg-pink-300 rounded"></div>
                      <div className="w-1/2 h-2 bg-pink-300 rounded"></div>
                    </div>
                    <p className="text-xs text-pink-700 font-medium">Activity Feed</p>
                  </div>
                </div>
                {/* Main Content */}
                <div className="col-span-7 bg-white rounded-lg p-3 border border-gray-200">
                  <div className="space-y-3">
                    <div className="flex space-x-2">
                      <div className="w-16 h-3 bg-indigo-300 rounded"></div>
                      <div className="w-16 h-3 bg-gray-300 rounded"></div>
                      <div className="w-16 h-3 bg-gray-300 rounded"></div>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <div className="h-16 bg-green-100 rounded border border-green-200"></div>
                      <div className="h-16 bg-yellow-100 rounded border border-yellow-200"></div>
                      <div className="h-16 bg-purple-100 rounded border border-purple-200"></div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-600 mt-2 font-medium">Main Content</p>
                </div>

                {/* Right Sidebar */}
               
              </div>
            </div>
          </div>

          {/* Mobile Layout Diagram */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
              <DevicePhoneMobileIcon className="w-5 h-5 mr-2 text-green-600" />
              Mobile View
            </h3>
            <div className="bg-gray-50 rounded-xl p-6 border-2 border-dashed border-gray-300 max-w-xs mx-auto">
              <div className="space-y-4">
                <div className="bg-blue-100 rounded-lg p-3 border border-blue-200">
                  <div className="w-6 h-1 bg-blue-300 rounded mb-2 mx-auto"></div>
                  <p className="text-xs text-blue-700 text-center font-medium">Menu Button</p>
                </div>
                <div className="bg-white rounded-lg p-3 border border-gray-200 min-h-32">
                  <div className="space-y-2">
                    <div className="w-full h-2 bg-indigo-300 rounded"></div>
                    <div className="w-3/4 h-2 bg-gray-300 rounded"></div>
                    <div className="grid grid-cols-2 gap-1 mt-2">
                      <div className="h-8 bg-green-100 rounded"></div>
                      <div className="h-8 bg-yellow-100 rounded"></div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-600 mt-2 text-center font-medium">Main Content</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Key Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <ChartBarIcon className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Statistics Overview</h3>
            <p className="text-gray-600">Key performance metrics and business insights at a glance</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <UsersIcon className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Team Management</h3>
            <p className="text-gray-600">Monitor staff schedules, shifts, and team activities</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <CalendarIcon className="w-6 h-6 text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Meeting Scheduler</h3>
            <p className="text-gray-600">Plan and track meetings with calendar integration</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
              <ClipboardDocumentListIcon className="w-6 h-6 text-yellow-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Task Management</h3>
            <p className="text-gray-600">Organize and track tasks for you and your team</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
              <NewspaperIcon className="w-6 h-6 text-red-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">News & Updates</h3>
            <p className="text-gray-600">Stay informed with company announcements and news</p>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
              <CloudIcon className="w-6 h-6 text-indigo-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Weather Integration</h3>
            <p className="text-gray-600">Check local weather forecasts for planning</p>
          </div>
        </div>

        {/* Navigation Sidebar */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <CogIcon className="w-6 h-6 mr-3 text-blue-600" />
            Navigation Menu
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {[
              { icon: ChartBarIcon, name: 'Dashboard', color: 'blue' },
              { icon: ChatBubbleLeftRightIcon, name: 'Chat', color: 'green' },
              { icon: UsersIcon, name: 'My Profile', color: 'purple' },
              { icon: BuildingOfficeIcon, name: 'Projects', color: 'yellow' },
              { icon: ClipboardDocumentListIcon, name: 'Task Manager', color: 'red' },
              { icon: UserGroupIcon, name: 'Recruitment', color: 'indigo' },
              { icon: CogIcon, name: 'Admin Tasks', color: 'gray' },
              { icon: CheckCircleIcon, name: 'Training', color: 'emerald' },
              { icon: BuildingOfficeIcon, name: 'Organization', color: 'cyan' },
              { icon: UsersIcon, name: 'Users', color: 'rose' },
              { icon: CreditCardIcon, name: 'Billing', color: 'amber' },
              { icon: ArrowRightOnRectangleIcon, name: 'Log Out', color: 'slate' }
            ].map((item, index) => (
              <div key={index} className={`bg-${item.color}-50 rounded-lg p-4 border border-${item.color}-200 hover:bg-${item.color}-100 transition-colors cursor-pointer`}>
                <item.icon className={`w-6 h-6 text-${item.color}-600 mb-2`} />
                <p className={`text-sm font-medium text-${item.color}-800`}>{item.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* How It Helps */}
        <div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl p-8 text-white mb-8">
          <h2 className="text-2xl font-bold mb-6">Why It Matters</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-3">
              <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold mb-1">Stay Organized</h3>
                <p className="text-blue-100">Everything in one place - no more switching between apps</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold mb-1">Monitor Your Team</h3>
                <p className="text-blue-100">Keep track of activities, tasks, and schedules</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold mb-1">Plan Ahead</h3>
                <p className="text-blue-100">Weather, meetings, and news help you prepare</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <CheckCircleIcon className="w-6 h-6 text-green-300 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold mb-1">Quick Access</h3>
                <p className="text-blue-100">Navigate instantly to any system section</p>
              </div>
            </div>
          </div>
        </div>

        {/* Getting Started */}
        <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <SparklesIcon className="w-6 h-6 mr-3 text-yellow-500" />
            Getting Started
          </h2>
          <div className="space-y-4">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">1</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Log In</h3>
                <p className="text-gray-600">Access your dashboard automatically after logging in</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">2</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Explore Tabs</h3>
                <p className="text-gray-600">Switch between Stats, Staff, Meetings, Tasks, and News</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">3</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Use Navigation</h3>
                <p className="text-gray-600">Click sidebar links to access different system areas</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">4</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Check Alerts</h3>
                <p className="text-gray-600">Look for notification boxes at the top of the screen</p>
              </div>
            </div>
          </div>

          <div className="mt-8 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
            <div className="flex items-start space-x-3">
              <ExclamationTriangleIcon className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="font-semibold text-yellow-800">Pro Tip</h3>
                <p className="text-yellow-700 text-sm">
                  If you see an onboarding reminder, follow the link to complete your setup for the best experience.
                  The AI assistant is always available for help with any questions!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}